module.exports = __webpack_public_path__ + "img/3.e8a0855b.png";